function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8829 0.154572C10.7903 0.0579834 10.6634 0 10.5318 0H2.65367C1.19995 0 0 1.18362 0 2.62314V17.3767C0 18.8164 1.19995 20 2.65367 20H13.3463C14.8 20 16 18.8164 16 17.3767V5.66177C16 5.53619 15.9415 5.4155 15.8586 5.32364L10.8829 0.154572ZM11.0244 1.70532L14.3561 5.16907H12.1903C11.5464 5.16907 11.0244 4.65698 11.0244 4.01932V1.70532ZM2.65367 19.0338H13.3463C14.2634 19.0338 15.0244 18.2851 15.0244 17.3767V6.13525H12.1903C11.005 6.13525 10.0488 5.19318 10.0488 4.01932V0.966187H2.65367C1.7366 0.966187 0.975617 1.71982 0.975617 2.62314V17.3767C0.975617 18.2851 1.74154 19.0338 2.65367 19.0338Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4531 17H2.54142C2.24369 17 2 17.2249 2 17.5C2 17.775 2.24369 18 2.54142 18H11.4586C11.7563 18 12 17.775 12 17.5C12 17.2249 11.7563 17 11.4531 17Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.67825 7.14487C6.76149 7.05435 6.87528 7 6.99779 7C7.12043 7 7.23422 7.05435 7.31732 7.14487L9.88257 9.99287C10.0489 10.1741 10.0358 10.4638 9.86072 10.6313C9.68554 10.8033 9.40541 10.7899 9.2435 10.6087L7.43554 8.60291V13.5472C7.43554 13.7963 7.23851 14 6.99779 14C6.75707 14 6.56004 13.7963 6.56004 13.5472V8.60291L4.7565 10.6087C4.59016 10.7897 4.31432 10.8033 4.13928 10.6313C3.96423 10.4592 3.9511 10.1739 4.11743 9.99287L6.67825 7.14487Z",
  fill: "white"
});

var SvgFileUploadIcon = function SvgFileUploadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileUploadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file_upload_icon.72de4749.svg";
export { ForwardRef as ReactComponent };